import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Identity, Configuration, Scoring and Questions are per-tenant — they live inside the
// Tenants detail view (/tenants/:code/…), not as top-level nav items.
const NAV_ITEMS = [
    { to: '/', icon: 'table-columns', label: 'Dashboard', end: true },
    { to: '/tenants', icon: 'building', label: 'Tenants' },
    { to: '/providers', icon: 'sitemap', label: 'Providers' },
    { to: '/funds', icon: 'wallet', label: 'Funds' },
    { to: '/model-training', icon: 'brain', label: 'Model Training' },
    { to: '/audit-log', icon: 'clock-rotate-left', label: 'Audit Log' },
    { to: '/settings', icon: 'gear', label: 'Settings' },
];

function Sidebar() {
    return (
        <nav className="admin-sidebar">
            <ul className="sidebar-nav">
                {NAV_ITEMS.map(({ to, icon, label, end }) => (
                    <li key={to}>
                        <NavLink
                            to={to}
                            end={end}
                            className={({ isActive }) =>
                                `sidebar-link${isActive ? ' active' : ''}`
                            }
                        >
                            <FontAwesomeIcon icon={icon} className="sidebar-icon" />
                            <span>{label}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}

export default Sidebar;
